import NavDropdown from "react-bootstrap/esm/NavDropdown";
import Popover from "react-bootstrap/esm/Popover";
import styled from "styled-components";

export const LoadingTextStyle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  text-align: center;
  font-size: 1rem;
`;

export const LoadingMessageStyle = styled.p`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-align: center;
  font-size: 1rem;
  margin: 0px;
`;

export const AvatarStyle = styled.div`
  background-image: url(${(props) => props.src});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
  position: absolute;
  border-radius: 50%;
  top: 13%;
  left: 13%;
  width: 70%;
  height: 70%;
`;

export const EmptyPageArticleStyle = styled.article`
  & p:first-child {
    color: #ddd3ab;
    font-weight: 600;
    margin-bottom: 0 !important;
  }
  &:last-child {
    color: #9b9371;
    font-weight: 400;
    margin-bottom: 0.5rem;
  }
`;

export const NewChatActionsStyle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: #2b251a1a;
  backdrop-filter: blur(10px);
  position: absolute;
  top: 50%;
  left: -500px;
  transform: translateY(-50%);
  z-index: 5;
  box-shadow: 0 -20px 30px #2b251a1a, 0 20px 30px #2b251a1a;
  opacity: 0;
`;

export const NavBarHeaderStyle = styled.div`
  border-radius: 0.5rem;

  & nav {
    display: flex;
    flex-wrap: nowrap;
    overflow: auto;
  }
  & button {
    color: #c8bca75e;
    font-size: 1rem;
    padding: 0.5rem;
    white-space: nowrap;
    border: 0;
  }
`;

export const ChatHeaderContentInfoStyled = styled.div`
  display: flex;
  flex-direction: column;
  width: 10rem;
  & span {
    display: inline-block;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;
  }
`;

export const ChatBarForm = styled.form<{
  $isReply?: boolean;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: end;
  position: "relative",
  // bottom: -40px;
  width: 100%;
  height: auto;
  // overflow: hidden;

  & button {
    all: unset;
    display: inline-block;
    cursor: pointer;
  }

  & button:not(:disabled).active-icon {
    filter: brightness(0) saturate(100%) invert(86%) sepia(19%) saturate(6613%) hue-rotate(331deg) brightness(97%) contrast(87%);
  }

  & button:disabled {
    all: unset;
    display: inline-block;
    cursor: default;
  }

`;

export const ReplyBoxStyled = styled.div`
  position: absolute;
  top: -15px;
  width: 100%;
`;

export const OnlyAdminMessageBoxStyled = styled.div<{
  $heightMessage?: number;
}>`
  --h: 56px;
  --max-h: 120px;
  --color: #50473d;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 90%;
  height: ${(props) => props.$heightMessage + 10 || 56}px;
  min-height: var(--h);
  max-height: var(--max-h);
  background: var(--color);
  border-right: 1px solid var(--color);
  border-left: 1px solid var(--color);
  position: relative;
  overflow: visible;
`;

export const PageChatContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: absolute;
  top: 70px;
  bottom: -40px;
  width: 100%;
`;

export const OctagonStyled = styled.div<{ $heightMessage?: number }>`
  --h: 56px;
  --max-h: 120px;
  --color: #50473d;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 90%;
  height: ${(props) => props.$heightMessage + 10 || 56}px;
  min-height: var(--h);
  max-height: var(--max-h);
  background: var(--color);
  border-right: 1px solid var(--color);
  border-left: 1px solid var(--color);
  position: relative;
  overflow: visible;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: -0.75rem;
    border-bottom: 10px solid transparent;
    border-right: 12px solid var(--color);
    border-top: 10px solid transparent;
    height: ${(props) => props.$heightMessage + 10 || 56}px;
    min-height: var(--h);
    max-height: var(--max-h);
    z-index: 3;
  }

  &:after {
    content: "";
    position: absolute;
    top: 0;
    right: -0.75rem;
    border-top: 10px solid transparent;
    border-left: 12px solid var(--color);
    border-bottom: 10px solid transparent;
    height: ${(props) => props.$heightMessage + 10 || 56}px;
    min-height: var(--h);
    max-height: var(--max-h);
    z-index: 3;
  }
  & > div {
    position: absolute;
    z-index: 4;
  }
  & > div:first-child {
    left: -5px;
  }
  & > div:last-child {
    right: -5px;
  }

  & textarea {
    width: 85% !important;
    min-height: 25px;
    height: auto;
    max-height: var(--max-h);
    -ms-overflow-style: none;
    scrollbar-width: none;
    box-sizing: border-box;
  }
  & textarea::-webkit-scrollbar {
    display: none;
  }
`;

export const PopoverEmojiStyled = styled(Popover)`
  background-image: url(/assets/images/backgrounds/main-bg-1.png);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 2222 !important;
  max-width: 300px;
  max-height: 284px;

  & .popover-arrow {
    display: none;
  }
  & .popover-header {
    height: 43px;
    border-bottom: 1px solid #585349;
    background-color: initial;
    color: #fff;
    font-size: 1rem;
    font-weight: 600;
  }
  & .popover-header img {
    cursor: pointer;
  }
  & .popover-body button {
    border-radius: 0px;
    border: none;
    background-color: transparent;
    background-image: url(/assets/images/backgrounds/item-frame-1.png);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
`;

export const DateMessagesStyle = styled.div`
  color: #b6a798;
  background-color: #b6a79842;
  -webkit-backdrop-filter: blur(40%);
  backdrop-filter: blur(40%);
  border: 1px solid #b6a798;
  border-radius: 5rem;
  min-width: 70px;
  text-align: center;
`;

export const BoxMessageStyle = styled.div<{
  $isMine?: boolean;
  $messageWidth: number;
}>`
  --background-color: ${(props) => (props.$isMine ? "#50BAC3" : "#2B251A")};
  --clip-path-indentation: ${(props) =>
    props?.$messageWidth > 100 ? "95%" : props.$isMine ? "85%" : "100%"};
  & {
    overflow: hidden;
  }

  & .specialForms::before {
    content: "";
    position: absolute;
    overflow: visible;
    bottom: 0 !important;
    right: 0 !important;
    left: 0 !important;
    border-top: 10px solid var(--background-color);
    transform: translate(0px, 100%) !important;
  }

  & .specialForms {
    display: block;
    position: relative;
    width: 100%;
    height: 10px;
    background-color: var(--background-color);
    border-radius: 0px;

    ${(props) =>
      props.$isMine
        ? `
              clip-path: polygon(0px 0px, 100% 0px, 100% 160%, var(--clip-path-indentation) 100%, 12px 100%, 0px 3px);
              border-bottom-left-radius: 2rem !important;
            `
        : `
              clip-path: polygon(0px 0px, 100% 0px, 100% 3px, 90% 100%, 12px 100%, 0px 160%);
              border-bottom-right-radius: 2rem !important;
    `};
  }

  & #date-message {
    direction: ltr;
    font-size: 0.75rem;
    font-weight: 400;
    color: #b6a798;
  }
`;

export const ContentMessageStyle = styled.div<{
  $isMine?: boolean;
}>`
  position: relative;
  background-color: ${(props) => (props.$isMine ? "#50BAC3" : "#2B251A")};
  direction: ltr;
  min-width: 80%;
  border-radius: 0.2rem;
  font-size: 0.875rem;
  font-weight: 500;

  border-radius: 0.2rem;
  border-bottom-right-radius: 0px !important;
  border-bottom-left-radius: 0px !important;

  & #translate-box {
    border-top: 3px solid rgb(102, 95, 79);
  }
`;

export const ConversationActionBoxStyled = styled.div<{
  $isAddRole?: boolean;
}>`
  --mask-image-white: ${(props) => (props.$isAddRole ? "75" : "50")};
  --width: ${(props) => (props.$isAddRole ? "25" : "20")};

  right: 0;
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(3px);
  mask-image: linear-gradient(
    to right,
    #383327 0%,
    white var(--mask-image-white) %,
    transparent 100%
  );
  -webkit-mask-image: linear-gradient(
    to left,
    #383327 0%,
    white var(--mask-image-white) %,
    transparent 100%
  );
  width: var(--width) %;
  z-index: 2;

  & button {
    background-color: transparent !important;
  }
`;

export const ToastMessageStyled = styled.div`
  width: 18rem;
  min-height: 6rem !important;
  background-size: 100% 100% !important;
  cursor: pointer;
  & {
    @media screen and (max-width: 500px) {
      width: 16rem;
    }
  }

  & #toast-message {
    width: 12rem;
  }

  & #toast-message .spinner-border {
    color: #877862;
  }

  & #toast-message p {
    width: 10rem;
  }
`;

export const NavDropdownUtilsStyled = styled(NavDropdown)`
  & .dropdown-menu {
    padding: 0.5rem;
  }
  & .dropdown-item {
    border-radius: 0.25rem;
  }
`;
